<template>
  <v-container fluid class="elements-page mt-4">
    <v-row>
      <v-col lg=6 cols=12>
        <v-card class="overflow-hidden align-center">
          <v-card-title class="pa-5 pb-3">
            <p>Rentalizer</p>
          </v-card-title>
          <v-card-text>
            <p class="fs-normal greyBold--text mb-5">Input property informantion to generate report</p>
            <v-form ref="form">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    label="Address"
                    ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="d-flex" cols="12" sm="4">
                  <v-select
                    :items="beds"
                    label="Number of Beds"
                  ></v-select>
                </v-col>
                <v-col class="d-flex" cols="12" sm="4">
                  <v-select
                    :items="baths"
                    label="Number of Baths"
                  ></v-select>
                </v-col>
                <v-col class="d-flex" cols="12" sm="4">
                  <v-select
                    :items="guests"
                    label="Number of Guests"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row justify="end">
                <v-btn
                  color="primary"
                  class="button-shadow mr-4">
                  Submit
                </v-btn>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col lg=6 cols="12">
        <v-card>
          <v-card-text class="rounded overflow-hidden">
            <div class="mapContainer">
              <GmapMap
                      :center="{lat: -37.813179, lng: 144.950259}"
                      :zoom="12"
                      style="width: 100%; height: inherit"
              >
                <GmapMarker
                        :position="{lat: -37.813179, lng: 144.950259}"
                />
              </GmapMap>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'Rentalizer',
    data: () => ({
      beds: ['studio', '1', '2', '3', '4', '5', '6+'],
      baths: ['1', '1.5', '2', '2.5', '3', '3.5', '4', '4.5', '5+'],
      guests: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16+'],
    }),
    methods: {
      getReport() {
        this.$refs.form.getReport()
      },
    },
  }
</script>

<stype src="./Rentalizer.scss" lang="scss" />
